import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import links from '../links';
import menus from '../menus3';

const Header = () => {
    // state for menu and link toggles
    const [menuOpen, setMenuOpen] = useState(false);
    const [linkOpen, setLinkOpen] = useState(false);

    // Effect to handle window resize
    useEffect(() => {
        const handleResize = () => {
        if (window.innerWidth >= 992) {
            // Reset mobile states when switching to desktop
            setMenuOpen(false);
            setLinkOpen(false);
        }
        };

        window.addEventListener("resize", handleResize);

        // Cleanup
        return () => {
        window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <header className="main-header">
            <div className="site-navigation " id="mainmenu-area">
                <nav className="navbar navbar-expand-lg">
                    <div className="container">
                        {/*<Link to="/" className="navbar-brand">
                            <img src="assets/images/NNAC.png" alt="Bookhunt" className="img-fluid"/>
                        </Link>*/}

                        <button className="navbar-toggler" type="button" onClick={() => setMenuOpen(!menuOpen)}>
                            <span className="fa fa-bars"></span>
                        </button>

                        <div className={`navbar-collapse ${menuOpen ? "open" : "close"}`} id="navbarMenu">
                            <ul className="navbar-nav me-auto">
                                <li className="nav-item dropdown">
                                    <Link to="#" className="nav-link dropdown-toggle"  
                                        id="navbar2" role="button" onClick={() => setLinkOpen(!linkOpen)} >Home <i className="fa fa-angle-down"></i>
                                    </Link>
                                    <ul className={`dropdown-menu  ${linkOpen ? "open" : "close"}`} >
                                        {
                                            links.map((data,i) => (
                                                
                                                <Link key={i} className="dropdown-item" to={data.tolink} onClick={() => {window.location.href=data.tolink}}>
                                                    {data.namelink}
                                                </Link>
                                            ))
                                        }
                                    </ul>
                                </li>

                                {
                                    menus.map((menu) => (
                                        <li className="nav-item " key={menu.id}><HashLink to={menu.tomenu} className="nav-link js-scroll-trigger">{menu.namemenu}</HashLink></li>
                                    ))
                                }  
                                
                            </ul>
                        </div>

                        {/* 
                        <div className="header-right-info d-none d-lg-block">
                            <ul className="header-socials">
                                <li><Link to="#"><i className="fab fa-facebook-f" aria-hidden="true" /></Link></li>
                                <li><Link to="#"><i className="fab fa-twitter" aria-hidden="true" /></Link></li>
                                <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true" /></Link></li>
                                <li><Link to="#"><i className="fab fa-pinterest" aria-hidden="true" /></Link></li>
                            </ul>
                        </div>*/}
                    </div> 
                </nav>
            </div>
        </header>
    );
}

export default Header;